import AIPlayerSummaryLoadingStateView from "./AIPlayerSummaryLoadingStateView";

/**
 * Props interface for AIPlayerSummaryLoadingStateContainer component
 */
interface AIPlayerSummaryLoadingStateContainerProps {
  isDark: boolean;
  isSmallScreen: boolean;
  statusMessage: string;
}

/**
 * AIPlayerSummaryLoadingStateContainer component - manages loading state logic
 *
 * Handles the loading state display for AI player summary generation.
 * Shows rotating status messages to provide user feedback during generation.
 * @param props - Component props
 * @param props.isDark - Whether dark theme is active
 * @param props.isSmallScreen - Whether the screen is small (mobile)
 * @param props.statusMessage - Current status message to display
 */
function AIPlayerSummaryLoadingStateContainer({
  isDark,
  isSmallScreen,
  statusMessage,
}: AIPlayerSummaryLoadingStateContainerProps) {
  return (
    <AIPlayerSummaryLoadingStateView
      isDark={isDark}
      isSmallScreen={isSmallScreen}
      statusMessage={statusMessage}
    />
  );
}

export default AIPlayerSummaryLoadingStateContainer;
